import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import type { ExecutiveFilterState } from 'api/executive/executive.types'
import InsightApi from 'api/executive/insight.api'
import type {
  GetNewPatientDetailParams,
  GetNewPatientDetailResponse,
} from 'api/executive/executive.types'

export function useNewPatientDetail(scopedFilters?: Partial<ExecutiveFilterState>) {
  return useExecutiveQuery<GetNewPatientDetailParams, GetNewPatientDetailResponse>(
    'insight.new-patient-detail',
    InsightApi.getNewPatientDetail,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        nationality: f.nationality ?? undefined,
        sourceChannel: f.sourceChannel ?? undefined,
        promotionId: f.promotionId ?? undefined,
      }
    },
    { scopedFilters }
  )
}
